import { render, staticRenderFns } from "./DemoList.vue?vue&type=template&id=045c386a&scoped=true"
import script from "./DemoList.vue?vue&type=script&lang=ts"
export * from "./DemoList.vue?vue&type=script&lang=ts"
import style0 from "./DemoList.vue?vue&type=style&index=0&id=045c386a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c386a",
  null
  
)

export default component.exports